// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.mail-head[data-v-08a76ab4]{\n\tbackground-color: var(--main-gray-1);\n}\n.mail-head>*>*[data-v-08a76ab4]:nth-child(odd){\n\ttext-align: right;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
